// src/components/guards/RequirePartner.jsx
import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import {
  getMyPortalAccess,
  isActivePartnerAccess,
  resolveDestinationFromAccess,
} from "../../lib/access/portalAccess";

export default function RequirePartner({ children }) {
  const { user, loading: authLoading } = useAuth();
  const location = useLocation();

  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);
  const [redirectTo, setRedirectTo] = useState("");

  useEffect(() => {
    let alive = true;

    async function checkAccess() {
      if (authLoading) return;

      if (!user?.id) {
        if (alive) {
          setAllowed(false);
          setRedirectTo("");
          setChecking(false);
        }

        return;
      }

      try {
        setChecking(true);

        const access = await getMyPortalAccess();

        if (!alive) return;

        if (isActivePartnerAccess(access)) {
          setAllowed(true);
          setRedirectTo("");
          setChecking(false);
          return;
        }

        const result = await resolveDestinationFromAccess({
          access,
          userId: user.id,
        });

        if (!alive) return;

        setAllowed(false);
        setRedirectTo(result.destination || "/login");
        setChecking(false);
      } catch (error) {
        console.error("Partner access check failed:", error);

        if (alive) {
          setAllowed(false);
          setRedirectTo("/partner/login?access=error");
          setChecking(false);
        }
      }
    }

    checkAccess();

    return () => {
      alive = false;
    };
  }, [user?.id, authLoading]);

  if (authLoading || checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FFF7ED] px-6 text-sm font-semibold text-[#757575]">
        Checking partner access…
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/partner/login"
        replace
        state={{ from: location }}
      />
    );
  }

  if (!allowed) {
    return (
      <Navigate
        to={redirectTo || "/login"}
        replace
      />
    );
  }

  return children;
}